import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { MdSearch } from 'react-icons/md';
import { isBooleanTrue, isStringNotEmpty } from '../../utils/objectUtils';
import Fieldset from '../FormFieldset';
import { v4 as uuid } from 'uuid';

const TableSearchBarWrapper = ({ title, children }) => {
    if (isStringNotEmpty(title)) {
        return (
            <Fieldset legend={title}>
                {children}
            </Fieldset>
        );
    } else {
        return children;
    }

};

const TableSearchBar = ({ formId = uuid(), title, colspan = null, search, isLoading, showName = true, showEmail = true, showPhone = true, showSubscriberId = false, showOrderId = false, showOrderRefId = false, showOrderAMDRefId = false, showUserId = false, showPatientId = false, showSubscriptionId = false, showTransactionId = false, showTransactionRefId = false, showVoucherId = false, showPurchasedOrderId = false, showEncounterId = false, showEncounterRefId = false, showLeadId = false, showPrescriptionId = false, showOrderNumber = false }) => {
    //#region useForms

    const nameMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const emailMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const phoneMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const subscriberIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const orderIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const orderRefIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const patientIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const orderAMDRefIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const subscriptionIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const userIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const transactionIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const transactionRefIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const voucherIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const purchasedOrderIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const encounterIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const encounterRefIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const leadIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const prescriptionIdMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });
    const orderNumberMethods = useForm({ mode: 'onSubmit', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });

    //#endregion

    return (
        <TableSearchBarWrapper title={title}>
            <ButtonToolbar className="justify-content-between mb-3 mt-3" aria-label="Toolbar with Button groups">
                <Row className="g-2">
                    {isBooleanTrue(showName) ? (
                        <Col xs={colspan}>
                            <FormProvider {...nameMethods}>
                                <Form onSubmit={nameMethods.handleSubmit(search)} id={`${formId}-SearchName`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <InputGroup>
                                        <Controller
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { invalid, isTouched, isDirty, error },
                                                formState,
                                            }) => (
                                                <Form.Control
                                                    placeholder="First Name"
                                                    onBlur={onBlur}
                                                    onChange={e => { onChange(e.target.value); }}
                                                    value={value}
                                                    name={name}
                                                    ref={ref}
                                                    isInvalid={invalid}
                                                />
                                            )}
                                            name="firstName"
                                        />
                                        <Controller
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { invalid, isTouched, isDirty, error },
                                                formState,
                                            }) => (
                                                <Form.Control
                                                    placeholder="Last Name"
                                                    onBlur={onBlur}
                                                    onChange={e => { onChange(e.target.value); }}
                                                    value={value}
                                                    name={name}
                                                    ref={ref}
                                                    isInvalid={invalid}
                                                />
                                            )}
                                            name="lastName"
                                        />
                                        <Button variant="primary" type="submit" form={`${formId}-SearchName`} disabled={isLoading}><MdSearch /></Button>
                                    </InputGroup>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showEmail) ? (
                        <Col xs={colspan}>
                            <FormProvider {...emailMethods}>
                                <Form onSubmit={emailMethods.handleSubmit(search)} id={`${formId}-SearchEmail`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <InputGroup>
                                        <Controller
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { invalid, isTouched, isDirty, error },
                                                formState,
                                            }) => (
                                                <Form.Control
                                                    placeholder="Email"
                                                    onBlur={onBlur}
                                                    onChange={e => { onChange(e.target.value); }}
                                                    value={value}
                                                    name={name}
                                                    ref={ref}
                                                    isInvalid={invalid}
                                                />
                                            )}
                                            rules={{
                                                required: false,
                                            }}
                                            name="email"
                                        />
                                        <Button variant="primary" type="submit" form={`${formId}-SearchEmail`} disabled={isLoading}><MdSearch /></Button>
                                    </InputGroup>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showPhone) ? (
                        <Col xs={colspan}>
                            <FormProvider {...phoneMethods}>
                                <Form onSubmit={phoneMethods.handleSubmit(search)} id={`${formId}-SearchPhone`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <InputGroup>
                                        <Controller
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { invalid, isTouched, isDirty, error },
                                                formState,
                                            }) => (
                                                <Form.Control
                                                    placeholder="Phone"
                                                    onBlur={onBlur}
                                                    onChange={e => { onChange(e.target.value); }}
                                                    value={value}
                                                    name={name}
                                                    ref={ref}
                                                    isInvalid={invalid}
                                                />
                                            )}
                                            rules={{
                                                required: false,
                                            }}
                                            name="phone"
                                        />
                                        <Button variant="primary" type="submit" form={`${formId}-SearchPhone`} disabled={isLoading}><MdSearch /></Button>
                                    </InputGroup>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showSubscriberId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...subscriberIdMethods}>
                                <Form onSubmit={subscriberIdMethods.handleSubmit(search)} id={`${formId}-SearchSubscriberId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <InputGroup>
                                        <Controller
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { invalid, isTouched, isDirty, error },
                                                formState,
                                            }) => (
                                                <Form.Control
                                                    placeholder="Subscriber ID"
                                                    onBlur={onBlur}
                                                    onChange={e => { onChange(e.target.value); }}
                                                    value={value}
                                                    name={name}
                                                    ref={ref}
                                                    isInvalid={invalid}
                                                />
                                            )}
                                            name="subscriberId"
                                        />
                                        <Button variant="primary" type="submit" form={`${formId}-SearchSubscriberId`} disabled={isLoading}><MdSearch /></Button>
                                    </InputGroup>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showOrderId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...orderIdMethods}>
                                <Form onSubmit={orderIdMethods.handleSubmit(search)} id={`${formId}-SearchOrderId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <InputGroup>
                                        <Controller
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { invalid, isTouched, isDirty, error },
                                                formState,
                                            }) => (
                                                <Form.Control
                                                    placeholder="Order ID"
                                                    onBlur={onBlur}
                                                    onChange={e => { onChange(e.target.value); }}
                                                    value={value}
                                                    name={name}
                                                    ref={ref}
                                                    isInvalid={invalid}
                                                />
                                            )}
                                            name="orderId"
                                        />
                                        <Button variant="primary" type="submit" form={`${formId}-SearchOrderId`} disabled={isLoading}><MdSearch /></Button>
                                    </InputGroup>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showOrderRefId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...orderRefIdMethods}>
                                <Form onSubmit={orderRefIdMethods.handleSubmit(search)} id={`${formId}-SearchOrderRefId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Order Ref ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="orderRefId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchOrderRefId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showOrderAMDRefId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...orderAMDRefIdMethods}>
                                <Form onSubmit={orderAMDRefIdMethods.handleSubmit(search)} id={`${formId}-SearchOrderAMDRefId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Visit ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="orderAMDRefId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchOrderAMDRefId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showPatientId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...patientIdMethods}>
                                <Form onSubmit={patientIdMethods.handleSubmit(search)} id={`${formId}-SearchPatientId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Patient ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="patientId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchPatientId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showUserId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...userIdMethods}>
                                <Form onSubmit={userIdMethods.handleSubmit(search)} id={`${formId}-SearchUserId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="User ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="userId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchUserId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showSubscriptionId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...subscriptionIdMethods}>
                                <Form onSubmit={subscriptionIdMethods.handleSubmit(search)} id={`${formId}-SearchSubscriptionId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Subscription ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="subscriptionId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchSubscriptionId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showTransactionId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...transactionIdMethods}>
                                <Form onSubmit={transactionIdMethods.handleSubmit(search)} id={`${formId}-SearchTransactionId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Transaction ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="transactionId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchTransactionId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showTransactionRefId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...transactionRefIdMethods}>
                                <Form onSubmit={transactionRefIdMethods.handleSubmit(search)} id={`${formId}-SearchTransactionRefId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Gateway Trx ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="transactionRefId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchTransactionRefId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showVoucherId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...voucherIdMethods}>
                                <Form onSubmit={voucherIdMethods.handleSubmit(search)} id={`${formId}-SearchVoucherId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Voucher ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="voucherId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchVoucherId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showPurchasedOrderId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...purchasedOrderIdMethods}>
                                <Form onSubmit={purchasedOrderIdMethods.handleSubmit(search)} id={`${formId}-SearchPurchasedOrderId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Purchased Order ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="purchasedOrderId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchPurchasedOrderId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showEncounterId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...encounterIdMethods}>
                                <Form onSubmit={encounterIdMethods.handleSubmit(search)} id={`${formId}-SearchEncounterId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Encounter ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="encounterId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchEncounterId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showEncounterRefId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...encounterRefIdMethods}>
                                <Form onSubmit={encounterRefIdMethods.handleSubmit(search)} id={`${formId}-SearchEncounterRefId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Encounter Ref ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="encounterRefId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchEncounterRefId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showLeadId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...leadIdMethods}>
                                <Form onSubmit={leadIdMethods.handleSubmit(search)} id={`${formId}-SearchLeadId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Lead ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="leadId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchLeadId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showPrescriptionId) ? (
                        <Col xs={colspan}>
                            <FormProvider {...prescriptionIdMethods}>
                                <Form onSubmit={prescriptionIdMethods.handleSubmit(search)} id={`${formId}-SearchPrescriptionId`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Prescription ID"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="prescriptionId"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchPrescriptionId`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                    {isBooleanTrue(showOrderNumber) ? (
                        <Col xs={colspan}>
                            <FormProvider {...orderNumberMethods}>
                                <Form onSubmit={orderNumberMethods.handleSubmit(search)} id={`${formId}-SearchOrderNumber`} style={{ padding: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid rgb(192, 192, 192)' }}>
                                    <Controller
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <Form.Control
                                                placeholder="Order Number"
                                                onBlur={onBlur}
                                                onChange={e => { onChange(e.target.value); }}
                                                value={value}
                                                name={name}
                                                ref={ref}
                                                isInvalid={invalid}
                                            />
                                        )}
                                        name="orderNumber"
                                    />
                                    <Button variant="primary" type="submit" form={`${formId}-SearchOrderNumber`} disabled={isLoading}><MdSearch /></Button>
                                </Form>
                            </FormProvider>
                        </Col>
                    ) : null}
                </Row>
            </ButtonToolbar>
        </TableSearchBarWrapper>
    );
};

TableSearchBar.propTypes = {
    search: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    showName: PropTypes.bool,
    showEmail: PropTypes.bool,
    showPhone: PropTypes.bool,
    showSubscriberId: PropTypes.bool,
    showOrderId: PropTypes.bool,
    showOrderRefId: PropTypes.bool,
    showOrderAMDRefId: PropTypes.bool,
    showPatientId: PropTypes.bool,
    showUserId: PropTypes.bool,
    showSubscriptionId: PropTypes.bool,
    showTransactionId: PropTypes.bool,
    showTransactionRefId: PropTypes.bool,
    showVoucherId: PropTypes.bool,
    showPurchasedOrderId: PropTypes.bool,
    showEncounterId: PropTypes.bool,
    showEncounterRefId: PropTypes.bool,
    showLeadId: PropTypes.bool,
    showPrescriptionId: PropTypes.bool,
    showOrderNumber: PropTypes.bool,
    formId: PropTypes.string
};

export default TableSearchBar;